<template>
  <ButtonBack />
  <div class="page-campaign">
    <div class="page-campaign-first-part">
      <CampaignDetail :campaign-uuid="route.params.campaignUuid" />
    </div>
    <div class="div-separator-32"></div>
    <TransactionList :campaign-uuid="route.params.campaignUuid" />
  </div>
</template>

<script setup>
  import { useRoute } from "vue-router";
  import ButtonBack from "@/components/ButtonBack.vue";
  import CampaignDetail from "@/components/Campaign/CampaignDetail.vue";
  import TransactionList from "@/components/Transaction/TransactionList.vue";

  const route = useRoute();
</script>

<style scoped lang="scss">
  .page-campaign {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .page-campaign-first-part {
      width: 100%;
    }
  }
</style>